export enum LeaveBaseType {
  FromContract = 0,
  FromContractWithDeductions = 1,
}
